import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "Components/Base/Inputs/Button";
import { Box } from "Components/Base/Layout/Box";
import InputLabelDatePicker from "Components/Fragment/InputLabelDatePicker";
import Reminder from "./Reminder";
import * as CONSTANTS from "../constants";
import { ItemTemplate } from "../templates";
import { getLangCode } from "lib/utils";
import PaperHeader from "Components/Fragment/PaperHeader";
import InputLabelHeader from "Components/Fragment/InputLabelHeader";
import { Grid } from "Components/Base/Layout/Grid";
import config from "lib/config";
import moment from "moment";
import { TextFieldMultiline } from "Components/Base/Inputs/TextFieldMultiline";

const ChecklistItem = (props) => {
  const { title, description, deadline, reminder } = props.item;
  let { lang } = props;

  let locale;
  if (!lang) lang = 2;
  locale = getLangCode(lang);

  const { languageContext, actions, onValidation, maxHeight } = props;
  const [displayValidationError, setDisplayValidationError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const validation = onValidation(props.item);

  const DATE_FORMAT =
    config && config.shortDateFormat && config.shortDateFormat.toUpperCase();

  const maxHeightCss =
    maxHeight === "initial" ? {} : { maxHeight, overflowY: "auto" };
  useEffect(() => {
    const handleKeyPress = (event) => {
      event.key === CONSTANTS.KEY_ESC && props.onCancel;
    };

    window.addEventListener("keypress", handleKeyPress);
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  });

  function onNameInputBlur(updatedName) {
    let updatedItem = Object.assign({}, props.item);
    updatedItem.title = updatedName;

    let validation = onValidation(updatedItem);

    setDisplayValidationError(!validation.itemtitle_valid);

    if (!validation.itemtitle_valid) {
      setErrorText(languageContext("errentertitle"));
    } else {
      setErrorText("");
    }

    actions.checklistItems_actions.onUpdateChecklistItem(updatedItem);
  }

  function onSetDescription(updatedDescription) {
    let updatedItem = Object.assign({}, props.item);
    updatedItem.description = updatedDescription;

    actions.checklistItems_actions.onUpdateChecklistItem(updatedItem);
  }

  function onSetDeadline(updatedDeadline) {
    let updatedItem = Object.assign({}, props.item);
    updatedItem.deadline = updatedDeadline;

    actions.checklistItems_actions.onUpdateChecklistItem(updatedItem);
  }

  function onUpdateReminder(updatedReminder) {
    let updatedItem = Object.assign({}, props.item);
    updatedItem.reminder = updatedReminder;

    let validation = onValidation(updatedItem);
    actions.checklistItems_actions.onUpdateChecklistItem(updatedItem);
  }

  const saveClickHandler = () => props.onSave(props.item);

  return (
    <PaperHeader
      heading={
        title === "" || title === null ? languageContext("addtask") : title
      }
      content={
        <div>
          <div style={maxHeightCss}>
            <Box ml={1} mt={1} sx={{ width: 350 }}>
              <InputLabelHeader
                type="text"
                header={languageContext("title")}
                required
                defaultValue={title}
                inputProps={{ onBlur: (e) => onNameInputBlur(e.target.value) }}
                error={displayValidationError}
                helperText={errorText}
              />
            </Box>
            <br />
            <Box m={1}>
              <TextFieldMultiline
                defaultValue={description}
                onBlur={(e) => onSetDescription(e.target.value)}
                label={languageContext("description")}
                fullWidth
              />
            </Box>
            <div className="padding-10">
              <InputLabelDatePicker
                id="CalDateDeadline"
                label={languageContext("deadline")}
                name={languageContext("deadline")}
                value={
                  deadline == "none"
                    ? null
                    : moment(deadline).format(DATE_FORMAT)
                }
                onChange={(event) => onSetDeadline(event.target.value)}
                oldStyleLabel={true}
              />
              {validation && !validation.itemdeadline_valid && (
                <span className="color-error">
                  {languageContext("invaliddate")}
                </span>
              )}
            </div>
            <hr />
            {reminder && (
              <Reminder
                languageContext={languageContext}
                reminder={reminder}
                onUpdate={onUpdateReminder}
                actions={actions.checklistReminder_actions}
                validation={validation}
                locale={locale}
              />
            )}
          </div>
          <Box pr={4}>
            <Grid container justifyContent="flex-end" spacing={1}>
              <Grid item>
                <Button
                  onClick={(e) =>
                    actions.checklistReminder_actions.onSendTestReminder(
                      title,
                      description,
                      deadline,
                      reminder,
                    )
                  }
                  label={languageContext("sendtestmail")}
                />
              </Grid>
              <Grid item>
                <Button
                  onClick={saveClickHandler}
                  label={languageContext("save")}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={props.onCancel}
                  label={languageContext("cancel")}
                />
              </Grid>
            </Grid>
          </Box>
        </div>
      }
    />
  );
};

ChecklistItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    checklistItemTypeID: PropTypes.number,
    deadlineID: PropTypes.number,
    courseID: PropTypes.number,
    description: PropTypes.string,
    priority: PropTypes.number,
    courseObjectID: PropTypes.number,
    itemOrder: PropTypes.number,
    deadline: PropTypes.string,
    completed: PropTypes.bool,
    completedBy: PropTypes.string,
    completedByName: PropTypes.string,
    completedDate: PropTypes.string,
    reminder: PropTypes.object,
  }),
  actions: PropTypes.object,
  languageContext: PropTypes.func.isRequired,
  onValidation: PropTypes.func.isRequired,
  maxHeight: PropTypes.string,
};

ChecklistItem.defaultProps = {
  item: ItemTemplate,
  actions: () => {},
  languageContext: () => {},
  onValidation: () => {},
  maxHeight: "initial",
};

export default ChecklistItem;
